module.exports = __webpack_public_path__ + "static/home-phone2-f228eb59131df339c802cc61a48a7251.png";